import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box } from '@mui/system';

// Components
import { TabEx } from '@Components/shared/selects/TabEx';
import { useTabs } from '@Components/shared/hooks/useTabs';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { TabsDrawerLayout } from '@Components/shared/layouts/TabsDrawerLayout';
import { SetupProviderDetails } from '../Tabs/Details';
import { SetupProviderCurrencies } from '../Tabs/Currencies';

// Styles
import Styles from './SetupProviderTabs.module.scss';

export const SetupProviderTabs: React.FC = () => {
  const { currentTab, handleSwithTab } = useTabs('1');

  return (
    <Box className={Styles.SetupProviderTabs}>
      <TabContext value={currentTab}>
        <TabsDrawerLayout
          header={
            <AtLocator type="tab-list" name="SetupRound">
              <TabList
                className={Styles.TablList}
                onChange={handleSwithTab}
                aria-label="Information tabs"
              >
                <TabEx label="Details" value="1" />
                <TabEx label="Currencies" value="2" />
              </TabList>
            </AtLocator>
          }
        >
          <TabPanel value="1" className={Styles.Panel}>
            <SetupProviderDetails />
          </TabPanel>
          <TabPanel value="2" className={Styles.Panel}>
            <SetupProviderCurrencies />
          </TabPanel>
        </TabsDrawerLayout>
      </TabContext>
    </Box>
  );
};
